import { render, staticRenderFns } from "./d2-container-full.vue?vue&type=template&id=d40c8c4c&scoped=true&"
import script from "./d2-container-full.vue?vue&type=script&lang=js&"
export * from "./d2-container-full.vue?vue&type=script&lang=js&"
import style0 from "./d2-container-full.vue?vue&type=style&index=0&id=d40c8c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40c8c4c",
  null
  
)

component.options.__file = "d2-container-full.vue"
export default component.exports